import React from "react";

const UPS6Spec = () => {
  return (
    <div>
      <div className="container py-16 ">
        <h1 className="text-6xl font-bold text-center py-6 uppercase">
          Specification
        </h1>
        

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
              Cells Per Unit
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">6
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Voltage Per Unit
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            12
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Weight
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            9Ah@20hr-rate to 1.75V per cell @25°C
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Max. Discharge Current
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            Approx. 2.5Kg
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Internal Resistance
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            90A (5 sec)
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Operating Temperature Range
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            Approx.1 8 mo
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Normal Operating Temperature Range
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            Discharge: -20°C-60°C Charge: 0°C-50°C Storage: -20°C-60°C
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Float charging Voltage
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            25°C+5°C
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Recommended Maximum Charging Current Limit
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            2.7 A
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Equalization and Cycle Service
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            14.6 to 14.8 VDC/unit Average at 25°C
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Self Discharge
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            Up to 6 months at 25°C. Self-discharge ratio less than 3% per month at 25°C. Please charge
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Terminal

            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            Terminal F1/F2
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 border-t-4 border-slate-300">
          <div className=" m-0 py-5 px-5">
            <p className="font-bold text-black m-0  py-5 px-5 text-3xl ">
            Container Material
            </p>
          </div>
          <div className=" m-0 py-5 px-5">
            <p className=" text-black m-0  py-6 px-5 text-[20px]">
            A.B.S. (UL94-HB), Flammability resistance of UL94-V1 can be available upon request.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UPS6Spec;
